import actionTypes from '../../action-types'

export default (userCustomerProductKeyId) => ({
  type: actionTypes.USER.INITIATE_IMPERSONATION,
  payload: { userCustomerProductKeyId },
})
